import { useState, FormEvent } from "react";
import { useAuth } from "../auth/authContext";
import { userService } from "../api/userService";
import '../styles.css';

const PasswordForm = () => {
    const { user } = useAuth();
    const [currentPassword, setCurrentPassword] = useState('');
    const [nextPassword, setNextPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [msg, setMsg] = useState<string | null>(null);
    const [err, setErr] = useState<string | null>(null);
    const [busy, setBusy] = useState(false);
    const { updateUserPassword } = userService();

    const onSubmit = async (e: FormEvent) => {
        if (!user?.id) return;
        e.preventDefault();
        setErr(null);
        setMsg(null);

        if (!currentPassword || !nextPassword || !confirmPassword) {
        setErr('All fields are required.');
        return;
        }
        if (nextPassword.length < 6) {
        setErr('New password must be at least 8 characters.');
        return;
        }
        if (nextPassword !== confirmPassword) {
        setErr('New passwords do not match.');
        return;
        }

        try {
            setBusy(true);
            // TODO: Replace with your API call
            const result = await updateUserPassword(user.id, currentPassword, nextPassword );
            await new Promise(r => setTimeout(r, 600));
            if (result) {
                setMsg('Password successfully updated.');
            } else {
                setErr('Failed to update password. Try again.');
            }
            setCurrentPassword('');
            setNextPassword('');
            setConfirmPassword('');
        } catch (e) {
            setErr('There was an ERROR: password update failed. Try again.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <section className="pwd-container">
            <div className="pwd-grid">
                <div>
                    <label>Current Password</label>
                    <div>
                        <input type="password" className='input-field' placeholder="Current Password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} />
                    </div>
                </div>
                <div>
                    <label>New Password</label>
                    <div>
                        <input type="password" className='input-field' placeholder="New Password" value={nextPassword} onChange={e => setNextPassword(e.target.value)} />
                    </div>
                    <label className="muted">Must be at least 6 characters.</label>
                </div>
                <div>
                    <label>Confirm New Password</label>
                    <div>
                        <input type="password" className='input-field' placeholder="Confirm New Password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
                    </div>
                </div>
                <div>
                    <button onClick={onSubmit} className='btn' disabled={busy}>{busy ? 'Saving…' : 'Update Password'}</button>
                </div>
            </div>
            {err && <p className="tint small" style={{color: "red"}}>{err}</p>}
            {msg && <p className="tint small" style={{color: "green"}}>{msg}</p>}
        </section>
    );
};

export default PasswordForm;